import { render, staticRenderFns } from "./DAdminAiAssistance.vue?vue&type=template&id=0805f9d4&scoped=true&"
import script from "./DAdminAiAssistance.vue?vue&type=script&lang=js&"
export * from "./DAdminAiAssistance.vue?vue&type=script&lang=js&"
import style0 from "./DAdminAiAssistance.vue?vue&type=style&index=0&id=0805f9d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805f9d4",
  null
  
)

export default component.exports